var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShips(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 325,
    viewBox: "0 0 650 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.091 25C100.091 11.1875 111.279 0 125.091 0C184.041 0 330.141 0 375.091 0C383.454 0 391.254 4.17489 395.891 11.1374C409.816 32.0249 438.466 75 438.466 75H625.091C634.179 75 642.554 79.9375 646.954 87.875C651.366 95.825 651.104 105.537 646.291 113.25C610.141 171.1 543.416 277.85 521.291 313.25C516.729 320.562 508.716 325 500.091 325C431.891 325 130.891 325 25.0914 325C16.7914 325 9.04143 320.888 4.39143 314.013C-0.25857 307.15 -1.19612 298.412 1.87888 290.712C17.0039 252.912 40.6789 193.737 51.8789 165.712C55.6789 156.225 64.8664 150 75.0914 150C89.2289 150 107.066 150 107.066 150L140.404 50H125.091C111.279 50 100.091 38.8125 100.091 25ZM430.991 125L280.991 200H92.0164L62.0164 275H486.241L579.991 125H430.991ZM388.579 90.3L361.716 50H193.116L159.779 150H269.191L388.579 90.3Z",
    fill: "#E8ECF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 325,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShips);
export default __webpack_public_path__ + "static/media/ships.f8db281a7f5b5ce51188e29e8fdcdf7f.svg";
export { ForwardRef as ReactComponent };